import React, { useState } from "react";
import { Beat } from "../../../redux/reducers/spinner";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../redux/actions";
// import {Rotate, Beat} from "../../../redux/reducers/spinner";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import Location from "../../includes/Location";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { removePlusSign } from "../../helper/phoneNumber";

function CreateAddress() {
  const dispatch = useDispatch();

  // Open and close the modals
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  //This is to get company details
  // const [myCompany, setMyCompany] = React.useState({});
  // useEffect(() => {
  //   let isUnmount = false;
  //   const getMyCompany = async () => {
  //     let companyData = JSON.parse(await localStorage.getItem("myCompany"));
  //     if (!isUnmount) {
  //       companyData && setMyCompany(companyData);
  //       companyData &&
  //         setData((data) => ({
  //           ...data,
  //           city: companyData.company_city,
  //           state: companyData.company_state,
  //           country: companyData.company_country,
  //         }));
  //     }
  //   };
  //   getMyCompany();
  //   return () => {
  //     isUnmount = true;
  //   };
  // }, []);

  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);

  // store the input data in state
  const [submitted, setSubmitted] = useState(false);
  let [address_phone, setAddressPhone] = useState("");
  address_phone = removePlusSign(address_phone);

  const [data, setData] = useState({
    name: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    longitude: "",
    latitude: "",
  });
  const { name, phone, address, city, state, country, longitude, latitude } =
    data;
  const creating = useSelector((state) => state.admin.creating);

  // Function that sets input data to state
  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((data) => ({ ...data, [name]: value }));
  };

  function handleRegion(e) {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: fromJson(value).name }));
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (name && address && city && state && country && address_phone) {
      // dispatch action to create data
      try {
        const response = await dispatch(
          userActions.createAddress({ ...data, phone: address_phone })
        );
        if (response) {
          dispatch(userActions.getMyAddresses());
        }
      } catch (error) {}

      handleClose();
    }
  };

  return (
    <div>
      <MDBContainer>
        <MDBBtn color="primary" onClick={() => setOpen(true)}>
          Add an address
        </MDBBtn>
        <MDBModal isOpen={open} toggle={handleClose}>
          <form name="form" onSubmit={handleSubmit}>
            <MDBModalHeader toggle={handleClose}>
              Add a new address to your address book
            </MDBModalHeader>
            <MDBModalBody>
              <div className="text-left row pt-4">
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && name ? " has-error" : "")
                  }
                >
                  <label htmlFor="name">Address name*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    onChange={handleChange}
                  />
                  {submitted && name && (
                    <div className="invalid-feedback">Name is required</div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && phone ? " has-error" : "")
                  }
                >
                  <label htmlFor="phone">Address phone number*</label>
                  <PhoneInput
                    defaultCountry="NG"
                    className="form-control"
                    value={phone}
                    onChange={setAddressPhone}
                  />
                  {submitted && phone && (
                    <div className="invalid-feedback">
                      Address phone is required
                    </div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && address ? " has-error" : "")
                  }
                >
                  <label htmlFor="address">Address*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    onChange={handleChange}
                  />
                  {submitted && address && (
                    <div className="invalid-feedback">Address is required.</div>
                  )}
                </div>

                {/* Here, we utilize the location component to get the location data */}
                <Location
                  country_id={locationId.country_id}
                  state_id={locationId.state_id}
                  city_id={locationId.city_id}
                  countryList={(value) => {
                    setLocationList({ ...locationList, countryList: value });
                  }}
                  stateList={(value) => {
                    setLocationList({ ...locationList, stateList: value });
                  }}
                  cityList={(value) => {
                    setLocationList({ ...locationList, cityList: value });
                  }}
                  country_name={data.country}
                  state_name={data.state}
                  city_name={data.city}
                />

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && country ? " has-error" : "")
                  }
                >
                  <label htmlFor="country">Customer country*</label>
                  <select
                    name="country"
                    className="form-control"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        country_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    <option>{data?.country || "Select Country"}</option>

                    {locationList.countryList &&
                      locationList.countryList.length > 0 &&
                      locationList.countryList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>

                  {submitted && country && (
                    <div className="invalid-feedback">Country is required</div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && state ? " has-error" : "")
                  }
                >
                  <label htmlFor="state">Customer state </label>
                  <select
                    name="state"
                    className="form-control"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        state_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    <option>{data.state || "Select State"}</option>
                    {locationList.stateList &&
                      locationList.stateList.length > 0 &&
                      locationList.stateList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {submitted && state && (
                    <div className="invalid-feedback">State is required.</div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && city ? " has-error" : "")
                  }
                >
                  <label htmlFor="city">Customer city* </label>
                  <select
                    name="city"
                    className="form-control"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        city_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    <option>{data.city || "Select city"}</option>

                    {locationList.cityList &&
                      locationList.cityList.length > 0 &&
                      locationList.cityList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {submitted && city && (
                    <div className="invalid-feedback">City is required</div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && longitude ? " has-error" : "")
                  }
                >
                  <label htmlFor="longitude">Longitude*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="longitude"
                    onChange={handleChange}
                  />
                  {submitted && longitude && (
                    <div className="invalid-feedback">
                      longitude is required.
                    </div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && latitude ? " has-error" : "")
                  }
                >
                  <label htmlFor="latitude">Latitude*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="latitude"
                    onChange={handleChange}
                  />
                  {submitted && latitude && (
                    <div className="invalid-feedback">
                      latitude is required.
                    </div>
                  )}
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={() => setOpen(false)}>
                Close
              </MDBBtn>
              <MDBBtn color="primary" type="submit">
                {creating === true ? (
                  <Beat loading={creating} />
                ) : (
                  "Create Customer"
                )}
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default CreateAddress;
